import { useJsApiLoader } from '@react-google-maps/api';
import { React_GOOGLE_MAPS_API_KEY } from '@hero/web-utils';

// Static libraries array - must be constant to prevent LoadScript reload
const GOOGLE_MAPS_LIBRARIES: ('maps' | 'places' | 'drawing' | 'geometry' | 'visualization')[] = [
  'maps',
];

/**
 * Hook for loading Google Maps API
 * @param apiKey - Optional API key. If not provided, uses VITE_GOOGLE_MAP_API_KEY from environment
 */
export function useMapLoader(apiKey?: string) {
  const finalApiKey = apiKey || React_GOOGLE_MAPS_API_KEY;

  // If no API key, return early without calling useJsApiLoader to avoid conflicts
  if (!finalApiKey || finalApiKey.trim() === '') {
    return {
      isLoaded: false,
      loadError: {
        message:
          'Google Maps API key is missing. Please set VITE_GOOGLE_MAP_API_KEY in your environment variables.',
      } as Error,
    };
  }

  // Always use the same options to prevent "Loader must not be called again with different options" error
  // Use static libraries array to prevent LoadScript reload warning
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: finalApiKey,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  return {
    isLoaded,
    loadError,
  };
}
